export const POSITION_BOTTOM_LEFT = 'bottom_left'
export const POSITION_BOTTOM_RIGHT = 'bottom_right'
export const POSITION_TOP_LEFT = 'top_left'
export const POSITION_TOP_RIGHT = 'top_right'
